import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import KeyDownEvent = JQuery.KeyDownEvent;

@Directive({
    selector: '[maxPrecision]'
})
export class MaxPrecisionDirective {

    // Properties
    @Input() maxPrecision: number;

    private allowedKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Control', 'Delete', 'Enter', 'NumLock' ];
    private disallowedKeys: Array<string> = ['Space'];

    constructor(private el: ElementRef) {}

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyDownEvent) {

        // Allow Backspace, end, and home keys
        if (this.allowedKeys.includes(event.key)) {
            return;
        }

        // Don't allow tab or space
        if (this.disallowedKeys.includes(event.key)) {
            event.preventDefault();
        }

        // Obtaining the new value
        let current: string = this.el.nativeElement.value;
        if (!current) {
            current = '';
        }
        const indexStart = event.target.selectionStart;
        const indexEnd = event.target.selectionEnd;
        const key = event.key;
        const next: string = current.slice(0, indexStart) + key + current.slice(indexEnd + Math.abs(0));
        const nextNumber: number = Number(next);

        // Obtaining the precision
        const precision = next.includes('.') ? next.length - next.indexOf('.') - 1 : -1;

        // Checking the new value
        if (
            precision <= this.maxPrecision
            && !isNaN(nextNumber)
        ) {
            return;
        }

        // Preventing if we haven't allowed it yet
        event.preventDefault();
        return;
    }
}
